import React from "react";

export default class Logos extends React.Component<{
    title?: string;
    body?: React.ReactNode;
    children?: React.ReactNode;
}> {
    render() {
        return <>
            <div className="w-full flex-col justify-start items-center gap-4 inline-flex">
                <div className="w-full h-px bg-[color:var(--separator-one-color)]" />

                { this.props.title || this.props.body ?
                <div className="flex-col justify-start items-center gap-2 flex">
                    {this.props.title ? <div className="self-stretch text-center text-[color:var(--titles-color)] headlineGeneralText leading-normal">
                        {this.props.title}
                    </div> : null }
                    {this.props.body ? <div className="w-full text-center text-[color:var(--text-color)] generalText leading-snug">
                        {this.props.body}
                    </div> : null }
                </div>
                : null }

                {this.props.children}
            </div>
        </>
    }
}